import { render, staticRenderFns } from "./signup-code.vue?vue&type=template&id=6ae988dd&scoped=true&"
import script from "./signup-code.vue?vue&type=script&lang=js&"
export * from "./signup-code.vue?vue&type=script&lang=js&"
import style0 from "./signup-code.vue?vue&type=style&index=0&id=6ae988dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae988dd",
  null
  
)

export default component.exports